import { Button, Group, Modal } from '@economic/gaudi';
import React from 'react';
import { Field } from '../../../../../shared/components/Form';
import { t } from '../../../../../shared/components/l10n/l10n';
import Icon from '../../../../../shared/components/ui/primitives/Icon';
import { SendByType } from '../../invoices/book-and-send/types';

export interface BulkBookOnlyReminderConfirmationDialogContentProps {
    onBack: () => void;
    onOk: () => void;
}

export function BulkBookOnlyReminderConfirmationDialogContent({
    onBack,
    onOk,
}: BulkBookOnlyReminderConfirmationDialogContentProps) {
    return (
        <>
            <Modal.Header>
                <Icon name="warning" className="book-and-send-dialog__exclamation-badge" aria-label="Confirmation" />
            </Modal.Header>
            <Modal.Content>
                <p className="book-and-send-dialog__sub-header">{t`FORM_BOOKANDSEND_BULK_REMINDER_BOOK_ONLY_CONFIRMATION_TEXT`}</p>
                <Field.Checkbox
                    name="skipBookOnlyConfirmation"
                    text={t`FORM_BOOKANDSEND_BULK_REMINDER_BOOK_ONLY_CONFIRMATION_DO_NOT_SHOW`}
                />
                <Field.Hidden name="sendByType" value={SendByType.undefined} />
            </Modal.Content>
            <Modal.Footer>
                <Group>
                    <Button onClick={onBack}>{t`FORM_BOOKANDSEND_BULK_REMINDER_BACK`}</Button>
                    <Button
                        appearance="primary"
                        type="submit"
                        onClick={onOk}>{t`FORM_BOOKANDSEND_BULK_REMINDER_BOOKONLY`}</Button>
                </Group>
            </Modal.Footer>
        </>
    );
}
